module.exports = __webpack_public_path__ + "static/media/signal-red@2x.5c487fa8.png";